<template>
  <app-modal v-model="isDialogOpened"
             :cancel-text="$t('project.signing-checklist.dialogs.SigningChecklistAddBeforeLeaveDialog.cancelButtonLabel')"
             :ok-text="$t('project.signing-checklist.dialogs.SigningChecklistAddBeforeLeaveDialog.okButtonLabel')"
             size="md"
             @cancel="closeDialog"
             @ok="confirmClick"
  >
    <template #title>{{ $t('project.signing-checklist.dialogs.SigningChecklistAddBeforeLeaveDialog.dialogTitle') }}</template>

    <template #body>
      <p>{{ $t("project.signing-checklist.dialogs.SigningChecklistAddBeforeLeaveDialog.dialogBody") }}</p>
    </template>
  </app-modal>
</template>

<script>
import { dialogMixin } from '@/mixins/dialogMixin'

export default {
  name: 'SigningChecklistAddBeforeLeaveDialog',
  mixins: [dialogMixin],
  methods: {
    confirmClick () {
      this.$emit('confirm')
      this.closeDialog()
    },
  },
}
</script>
